import { useEffect, useState } from "react";
import { Button, Container, Grid, Paper, Typography, useTheme } from "@mui/material";
import SectionHeader from "../../../../components/merchants/SectionHeader";
import CustomBreadcrumbs from "../../../../components/breadcrumbs";
import { faInfoCircle, faTags } from "@fortawesome/free-solid-svg-icons";
import SectionTitle from "../../../../components/sectionTitle";

import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { deleteAttribute, getAttributes } from "../../../../controllers/company/products/AttributesController";
import AttributesDataTable from "./dataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QUDProgress from "../../../../components/progress";

export default function Attributes()
{
    const theme = useTheme();
    const [attributes,setAttributes] = useState([]);

    const [isLoading,setIsLoading] = useState(false);
    const [openDeleteDialog,setOpenDeleteDialog] = useState(false);

    useEffect(()=>{
        window.scrollTo(0,0);
        handleGetAttributes();
    },[]);

    const history = useHistory();

    const redirect = (route) => {
        history.push(route)
    }

    const handleGetAttributes = async () => {
        const response = await getAttributes();
        if(response.success === true)
        {
            setAttributes(response.data);
        }
    }

    const handleDeleteAttribute = async (id) => {
        setIsLoading(true);
        const response = await deleteAttribute(id);
        if(response.success === true)
        {
            //await handleGetAttributes();
            handleGetAttributes();
            //setAttributes(prevAttributes => prevAttributes.filter(attribute => attribute.id !== id));
        }
        setIsLoading(false);
    }

    


    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs returnTo='/products' crumbs={[{name:'Productos',link:'/products'},{name:'Atributos',link:'/products/attributes'}]}/>
            <br/>
            <SectionTitle title='Atributos' subtitle={'(Productos)'} />
            <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={12} lg={8}>
                    <Paper elevation={3} style={{padding:15,backgroundColor:'#ebf9ff'}}>
                        <Grid container alignContent={'center'} justifyContent={'center'}>
                            <Grid item xs={12} lg={2} textAlign={'center'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                <FontAwesomeIcon icon={faInfoCircle} size='2x' color={theme.palette.link.main}/>
                            </Grid>
                            <Grid item xs={12} lg={10}>
                               <Typography variant="h6" color={theme.palette.link.main} gutterBottom>
                                    ¿Qué son los Atributos?
                                </Typography>
                                <Typography variant="body1" color={theme.palette.text.secondary} gutterBottom>
                                    Los Atributos son las opciones principales que definen un producto. Son las características que 
                                    el cliente debe seleccionar antes de comprar (si aplica).
                                    <br/>Cada combinación de atributos (ej. "Talla M" + "Color Rojo") crea una Variante única, que te permite gestionar su propio precio, cantidad (stock) y SKU
                                    <br/>Ejemplos: Talla, Color, Sabor, Material, Capacidad.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} lg={12} mt={5}>
                    <Button
                        mt={5}
                        variant='contained'
                        endIcon={<AddCircleIcon/>}
                        onClick={()=>redirect('/products/attributes/create')}
                    >
                        <Typography>Agregar</Typography>
                    </Button>
                </Grid>
            </Grid>
            

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <br/>
                    <AttributesDataTable
                        attributes={attributes}
                        onDeleteAttribute={handleDeleteAttribute}
                        isLoading={isLoading}
                    />
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
        </Container>
    )
}